// extracted by mini-css-extract-plugin
export default {"video":"YoutubeEmbed_video__HP9FY","iframe":"YoutubeEmbed_iframe__619W+","playOverlay":"YoutubeEmbed_playOverlay__Kx1Ym"};